import React, { createContext, useCallback, useContext, useState } from "react";

export const DeliberationListContext = createContext({});

export const DeliberationListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      requester: undefined,
      presenter: undefined,
      directory: undefined,
      finalDeliberationStatus: [],
      companies: [],
      committees: [],
      modality: undefined,
      startDate: null,
      endDate: null,
      keyword: "",
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      filterParams: params,
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      pagination: paginationOption,
    }));
  }, []);

  return (
    <DeliberationListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </DeliberationListContext.Provider>
  );
};

export function useDeliberationList() {
  const context = useContext(DeliberationListContext);

  if (!context) {
    throw new Error(
      "useDeliberationList must be used within an DeliberationListProvider."
    );
  }

  return context;
}
